import React, { FC } from 'react';
import { Theme, Svg } from 'styled';
import { Color } from 'styled/theme/colors';

type Props = {
  className?: string;
  color: Color;
};

const LinkedInIcon: FC<Props> = ({ className = '', color = 'white' }) => (
  <Svg
    width="28px"
    height="29px"
    viewBox="0 0 28 29"
    className={className}
    fill="transparent"
  >
    <desc>LinkedIn Icon.</desc>
    <path
      d="M27.5 14.3899C27.5 21.8457 21.4558 27.8899 14 27.8899C6.54416 27.8899 0.5 21.8457 0.5 14.3899C0.5 6.93405 6.54416 0.889893 14 0.889893C21.4558 0.889893 27.5 6.93405 27.5 14.3899Z"
      stroke={Theme.colors[color]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.414 11.6636H7.35449V20.8562H10.414V11.6636Z"
      fill={Theme.colors[color]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6158 8.82002C10.5959 7.91869 9.95139 7.23218 8.90474 7.23218C7.85809 7.23218 7.17383 7.91869 7.17383 8.82002C7.17383 9.70268 7.83787 10.409 8.86502 10.409H8.88457C9.95139 10.409 10.6158 9.70268 10.6158 8.82002Z"
      fill={Theme.colors[color]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4482 15.5857C21.4482 12.7621 19.9389 11.448 17.9256 11.448C16.3012 11.448 15.5739 12.3402 15.1678 12.9662V11.6641H12.1079C12.1482 12.5267 12.1079 20.8567 12.1079 20.8567H15.1678V15.7228C15.1678 15.4481 15.1877 15.174 15.2686 14.9773C15.4897 14.4284 15.9932 13.8602 16.8384 13.8602C17.946 13.8602 18.3887 14.7031 18.3887 15.9384V20.8565H21.4481L21.4482 15.5857Z"
      fill={Theme.colors[color]}
    />
  </Svg>
);

export default LinkedInIcon;
